module.exports = __webpack_public_path__ + "img/twitter-icon.a6fd0456.svg";